import { connect } from 'react-redux'
import { setTradeIn } from '../../actions'
import ManualSearch from './ManualSearch'

const mapStateToProps = state => ({
  tradeIn: state.tradeIn,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(ManualSearch)
